import React from "react";
import Title from "../../../components/Title/Title";
import './SponsorsPage.scss';

const Sponsors2027page = () => {
    return (
        <div>
            <Title>Sponsors</Title>
            <p>
                [COMING SOON]
            </p>
        </div>
    );
}

export default Sponsors2027page
